import { Box, Spinner } from '@chakra-ui/react';

interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  color?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'lg',
  color = 'yooga.500',
}) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" py={8}>
      <Spinner size={size} color={color} />
    </Box>
  );
};

export default LoadingSpinner;
